import React from "react";
import { Row, Col, Divider } from "antd";
import "./index.less";

import footerLogo from "@/assets/icon/footerLogo.png";
import jinyuLogo from "@/assets/icon/jinyuLogo.png";
import huayijiaLogo from "@/assets/icon/huayijiaLogo.png";

import { useTranslation } from 'react-i18next';
function Footer() {
  const { t, i18n } = useTranslation();
  return (
    <footer className='footer'>
      <section className="footer-wrap">
        <Row justify="space-evenly">
          <Col xs={0} sm={1} ></Col>
          <Col xs={24} sm={4} className="footer-wrap-contacts">
            <div  className="footer-wrap-contacts-logo">
              <img src={footerLogo} alt="blur-logo"/>
            </div>
          </Col>

          <Col xs={24} sm={4} className="footer-wrap-addresses">
            <div className="footer-wrap-addresses-item footer-wrap-addresses-item-title">
              客服热线
            </div>
            <div className="footer-wrap-addresses-item footer-wrap-addresses-item-script">
              0898-68507057
            </div>
          </Col>
          <Col xs={24} sm={6} className="footer-wrap-addresses">
            <div className="footer-wrap-addresses-item footer-wrap-addresses-item-title">
              服务支持
            </div>
            <div className="footer-wrap-addresses-item footer-wrap-addresses-item-script">
              售后服务：sale@huayijia.tech
            </div>
            <div className="footer-wrap-addresses-item footer-wrap-addresses-item-script">
              商务合作：sale@huayijia.tech
            </div>
          </Col>
          <Col xs={24} sm={4}  className="footer-wrap-addresses">
            <div className="footer-wrap-addresses-item footer-wrap-addresses-item-title">
              公众号
            </div>
            <div className="footer-wrap-addresses-item footer-wrap-addresses-item-script">
              {/* <img src={huayijiaLogo} width="80px" height="80px" alt="华亿嘉" /> */}
              <img src={jinyuLogo} width="80px" height="80px" alt="锦誉征信" />
            </div>
          </Col>
          <Col xs={24} sm={3} className="footer-wrap-addresses">
            <div className="footer-wrap-addresses-item footer-wrap-addresses-item-title">
              友情链接
            </div>
            {/* <div className="footer-wrap-addresses-item footer-wrap-addresses-item-script">
              <a href="http://www.huayijia.tech/">华亿嘉科技</a>
            </div> */}
            <div className="footer-wrap-addresses-item footer-wrap-addresses-item-script">
              <a href="https://www.glp.com.cn/">普洛斯</a>
            </div>
          </Col>
          <Col xs={0} sm={2}></Col>
        </Row>
      </section>
      <section className="footer-beian">
        <Row>
          <Col xs={24} sm={24} className="footer-beian-company">
            ©2019-2026 锦誉征信 琼ICP备2020005003号-1 ⋅ 本网站已支持IPV6访问
          </Col>
        </Row>
      </section>
    </footer>
  );
}

export default Footer;
